module.exports = __webpack_public_path__ + "static/car1-0d9147f255aefdd01f84f0ff472a7f16.png";